// extracted by mini-css-extract-plugin
export default {"cls1":"Tooltip-cls1___8014d7077239131e517","cls2":"Tooltip-cls2___21fb55c0272dfd7be24 Tooltip-cls1___8014d7077239131e517"};